import React, { useEffect, useRef, useState } from "react";
import { Table, Input, message, ConfigProvider, Spin, Space, Button, Form, Drawer, Row, Col, Upload, UploadFile, Modal } from "antd";
import { formatDateTime, getLabel, isNotNullUndefined, isNotNullUndefinedBlank } from "../helpers/common";
import Pagination from "../helpers/pagination";
import { storage } from "../utils/storage";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useGetAttendantEarningPaymentHistory, useGetAttendantPaymentHistory, useUpdateAgentEarning } from "../services/attendantsearningpaymenthistory.service";
import IResponse from "../types/response";
import { eventEmitter } from "../helpers/eventemitter";
import { azureBlobStorageConfig } from "../helpers/config";
import { BlobServiceClient } from "@azure/storage-blob";
import { IAgentPaymentHistory, IAttendantsEarningPaymentHistory } from "../types/attendantsearningpaymenthistory";
import { useGetSasToken } from '../services/blobcontext.service';
import { useAuth } from "../context/AuthContext";
const AttendantsEarningPaymentHistory: React.FC = () => {
    const { Search } = Input;
    const { Column } = Table;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [loading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [paymentOpen, setPaymentOpen] = useState(false);
    const [modalType, setModalType] = useState<'delete' | 'add' | 'update' | ''>('');
    const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
    const [formUpdateValues, setFormUpdateValues] = useState<any>({});
    const [previewVisible, setPreviewVisible] = useState(false);
    const [attendantsEarningPaymentHistory, setAttendantsEarningPaymentHistory] = useState<IAttendantsEarningPaymentHistory[]>([]);
    const [agentPaymentHistory, setAgentPaymentHistory] = useState<IAgentPaymentHistory[]>([]);
    const [featuredImage, setFeaturedImage] = useState<UploadFile[]>([]);
    const [previewImage, setPreviewImage] = useState('');
    const pageNumber = useRef(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const searchValue = useRef<string>("");
    const [isImageUploading, setIsImageUploading] = useState(false);
    const [sasToken, setSasToken] = useState<string | null>(null);
    const { hasPermission, permissionsLoaded, loadPermissions } = useAuth();

    useEffect(() => {
            loadPermissions();
    }, [permissionsLoaded]);
    
    const AttendantsEarinngRead = hasPermission("ATTENDANTS_EARNING", "READ");
    const AttendantsEarinngEdit = hasPermission("ATTENDANTS_EARNING", "UPDATE");
    //#region on-load useEffect operations
    useEffect(() => {
        let userRoleId = parseInt(storage.getUserRoleId() ?? "0");
         if (![1, 4].includes(userRoleId)) {
            navigate("/");
        } else {
            setIsLoading(true);
            fetchAttendantsEarningPaymentHistory(searchValue.current ?? "", pageNumber.current, pageSize);
            getSasToken();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageSize]);

    const getSasToken = () => {
        getSasTokenMutation.mutate({});
    }

    const getSasTokenMutation = useGetSasToken({
        onSuccess: (response: IResponse) => {
            if (response?.data != null) {
                setSasToken(response.data);
                message.success(response.statusMessage);
                return;
            }

            message.error(response.statusMessage);

        },
        onError: (error) => {
            message.error(error.message);
        }
    });

    const showDrawer = (record: any) => {
        form.setFieldsValue({
            agentID: record.agentID,
        });
        setIsLoading(false);
        setOpen(true);
    }

    const showPaymentDrawer = (record: any) => {
        getPaymentHistory(record);
        setPaymentOpen(true);
    };

    const getPaymentHistory = async (data: any) => {
        getAttendantPaymentHistoryMutation.mutate(data);
    };

    const getAttendantPaymentHistoryMutation = useGetAttendantPaymentHistory({
        onSuccess: (response: IResponse) => {
            if (response.statusCode === 200) {
                const formattedData = response.data?.map((data: any) => ({
                    ...data,
                    startDate: formatDateTime(data.startDate, "DD/MM/YYYY"),
                    endDate: formatDateTime(data.endDate, "DD/MM/YYYY"),
                    updatedAt: formatDateTime(data.updatedAt, "DD/MM/YYYY"),
                    paymentProofImage: data.paymentProofImage + '?' + sasToken,
                }))
                setAgentPaymentHistory(formattedData);
            }
            else {
                message.error('Error fetching trip payment history.');
            }
        },
        onError: (error: any) => {
            message.error(error.message);
        }
    });

    //#region pagination operation
    const handlePageChange = (newPage: number) => {
        pageNumber.current = newPage;
        const size = pageSize;
        setPageSize(size);
        fetchAttendantsEarningPaymentHistory(searchValue.current ?? "", pageNumber.current, pageSize);
    };

    const onSearch = (value: any) => {
        pageNumber.current = 1;
        setPageSize(10);
        searchValue.current = value;
        fetchAttendantsEarningPaymentHistory(value, pageNumber.current, pageSize);
    };

    function getBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = error => reject(error);
        });
    };

    const handlePreviewCancel = () => setPreviewVisible(false);

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div className="ant-upload-text">Upload</div>
        </div>
    );

    const handlePreview = async (file: UploadFile) => {
        debugger
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as File);
        }
        setPreviewImage(file.url || (file.preview as string));
        setPreviewVisible(true);
    };

    const handleSave = () => {
        try {
            if (modalType === 'add') {
                setIsLoading(true);
                updateAttendantsEarningPaymentHistory.mutate({ agentID: formUpdateValues.agentID, comment: formUpdateValues.comment, paymentProofImage: formUpdateValues.paymentProofImage.file.url });
            }
            setIsConfirmModalVisible(false);
        } catch (error) {
            message.error('Failed to save');
        }
    };

    const updateAttendantsEarningPaymentHistory = useUpdateAgentEarning({
        onSuccess: (response: any) => {
            if (response.statusCode === 200) {
                // fetchCommissionsList("", "", "");
                let succesMessage = "Attendant Earning has been updated successfully!";
                setIsLoading(false);
                message.success(succesMessage);
            } else {
                setIsLoading(false);
                message.error(response.statusMessage);
            }
            onClose();
            form.resetFields();
        },
        onError: (error: any) => {
            setIsLoading(false);
            message.error(error.statusMessage);
        }
    });

    const handleCancel = () => {
        setIsLoading(false);
        setIsConfirmModalVisible(false);
    };

    const fetchAttendantsEarningPaymentHistory = async (searchFilter: string, pageNumber: number, pageSize: number) => {
        setIsLoading(true);
        setAttendantsEarningPaymentHistory([]);
        fetchAttendantsEarningPaymentHistoryMutation.mutate({ searchFilter: searchFilter, pageNumber: pageNumber, pageSize: pageSize });
    };

    const fetchAttendantsEarningPaymentHistoryMutation = useGetAttendantEarningPaymentHistory({
        onSuccess: (response: IResponse) => {
            if (response.statusCode === 200) {
                if (isNotNullUndefined(response.data) && response.data.length > 0) {
                    const formattedData = response.data.map((data: any) => ({
                        ...data,
                        createdAt: formatDateTime(data.createdAt, "DD/MM/YYYY HH:mm AMPM"),
                        startDate: formatDateTime(data.startDate, "DD/MM/YYYY HH:mm AMPM"),
                        endDate: formatDateTime(data.endDate, "DD/MM/YYYY HH:mm AMPM"),
                        updatedAt: formatDateTime(data.updatedAt, "DD/MM/YYYY HH:mm AMPM"),
                        totalEarnings: `$${(data.totalEarnings ?? 0).toFixed(2)}`,
                    }));
                    setAttendantsEarningPaymentHistory(formattedData);
                    const recordCount = response.data[0]?.recordCount;
                    setTotalPages(Math.ceil(recordCount / pageSize));
                    setIsLoading(false);
                } else {
                    setAttendantsEarningPaymentHistory([]);
                    setIsLoading(false);
                }
            } else {
                message.error(response.statusMessage);
                setIsLoading(false);
            }
        },
        onError: (error: any) => {
            message.error(error.message);
            setIsLoading(false);
        }
    });

    const onClose = () => {
        setOpen(false);
        eventEmitter.emit("clickableChange", false);
        form.resetFields();
    };

    const onPaymentClose = () => {
        setPaymentOpen(false);
        eventEmitter.emit("clickableChange", false);
    };

    const onFinish = (values: any) => {
        setModalType('add');
        setIsConfirmModalVisible(true);
        setFormUpdateValues(values);
    }

    const getModalTitle = () => {
        let message = "";
        if (modalType === 'delete') {
            message = "Confirm Deactivation!";
        } else if (modalType === 'add') {
            message = "Confirm Update!";
        }
        return message;
    }

    const getModelContent = () => {
        let modalContent = <></>;
        if (modalType === "add") {
            modalContent = (
                <p>Are you sure you want to <b>Update</b> this Attendant's Earning request?<b>Do you wish to proceed?</b></p>
            );
        }
        return modalContent;
    }

    const handleImageChange = async ({ fileList }: { fileList: UploadFile[]; }) => {
        if (fileList.length > 0) {
            // Loop through each file in the list.
            for (const x of fileList) {
                if (x.status === 'uploading' && x.originFileObj && !x.url) {
                    // Generate a unique file name.
                    const fileExtension = x.originFileObj.name.split(".").pop();
                    const fileName = "attendant_earning" + new Date().getTime() + "." + fileExtension;
                    try {
                        setIsImageUploading(true);
                        // Initialize the BlobServiceClient using account name and SAS token.
                        const blobServiceClient = new BlobServiceClient(
                            `https://${azureBlobStorageConfig.accountName}.blob.core.windows.net/?${sasToken}`
                        );
                        // Get the container client.
                        const containerClient = blobServiceClient.getContainerClient(azureBlobStorageConfig.containerName as string);
                        // Define the blob path (using a "temp/" folder).
                        const blobPath = "temp/" + fileName;
                        const blockBlobClient = containerClient.getBlockBlobClient(blobPath);
                        // Upload the file using the browser data API.
                        await blockBlobClient.uploadBrowserData(x.originFileObj, {
                            blobHTTPHeaders: { blobContentType: x.originFileObj.type }
                        });
                        // Get the URL of the uploaded blob.
                        const fileUrl = blockBlobClient.url;
                        x.url = fileUrl;
                        const featuredImageFile: UploadFile = {
                            uid: '1',
                            name: 'Attendant Earning',
                            status: 'done',
                            url: fileUrl,
                        };
                        setFeaturedImage([featuredImageFile]);
                    } catch (error: any) {
                        message.error(error.message || 'Something went wrong. Please try again!');
                        return false;
                    } finally {
                        setIsImageUploading(false);
                    }
                }
            }
        }
    };

    const onDeleteFeatureImageFile = async (file: UploadFile<any>) => {
        if (file && isNotNullUndefinedBlank(file.url)) {
            const fileName = file.url?.split('/').pop();
            if (isNotNullUndefinedBlank(fileName)) {
                try {
                    // Initialize the BlobServiceClient.
                    const blobServiceClient = new BlobServiceClient(
                        `https://${azureBlobStorageConfig.accountName}.blob.core.windows.net/?${sasToken}`
                    );
                    // Get the container client.
                    const containerClient = blobServiceClient.getContainerClient(azureBlobStorageConfig.containerName as string);
                    // Determine the blob path based on the file URL.
                    let blobPath = "";
                    if (file.url?.includes("/temp/")) {
                        blobPath = "temp/" + fileName;
                    } else {
                        // For single file uploads, if not in "temp", assume it is in "Attendant-Earning/".
                        blobPath = "Attendant-Earning/" + fileName;
                    }
                    const blockBlobClient = containerClient.getBlockBlobClient(blobPath);
                    await blockBlobClient.deleteIfExists();
                } catch (error: any) {
                    message.error("Error deleting file: " + error.message);
                    return false;
                }
                const images = featuredImage.filter(x => x.url !== file.url);
                setFeaturedImage(images);
            }
        }
    };

    return (
        <div>
            <div className="flex justify-between align-middle pb-5">
                <h2 className="text-2xl font-semibold text-black">Attendants Earning</h2>
                <div className="w-80 max-w-80">
                    <Search
                        placeholder="Search Commission Summary"
                        size="large"
                        enterButton
                        className="search-field"
                        onSearch={onSearch}
                    />
                </div>
            </div>

            <ConfigProvider
                theme={{
                    components: {
                        Tabs: {
                            titleFontSizeLG: 16,
                        },
                    }
                }}
            >
                <Table dataSource={attendantsEarningPaymentHistory} className="overflow-scroll" bordered pagination={{ pageSize: pageSize, position: ['none'] }}
                    locale={{
                        emptyText: loading ? <Spin /> : (
                            <div className="ant-empty">
                                <div className="ant-empty-image">
                                    <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg">
                                        <g transform="translate(0 1)" fill="none" fillRule="evenodd">
                                            <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
                                            <g fillRule="nonzero" stroke="#d9d9d9">
                                                <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                                                <path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#fafafa"></path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                <div className="ant-empty-description">No data</div>
                            </div>
                        )
                    }}>
                    <Column title="Attendant Name" dataIndex="agentName" key="agentName" align="center" width={200} />
                    <Column title="Attendant Email" dataIndex="agentEmail" key="agentEmail" align="center" width={150} />
                    <Column title="From Date" dataIndex="startDate" key="startDate" align="center" width={200} />
                    <Column title="To Date" dataIndex="endDate" key="endDate" align="center" width={200} />
                    <Column title="Updated At" dataIndex="updatedAt" key="updatedAt" width={200} />
                    <Column title="Total Earnings" dataIndex="totalEarnings" key="totalEarnings" align="center" width={150} />
                    <Column
                        align="center"
                        title="Action"
                        key="action"
                        width={150}
                        render={(_: any, record: any) => (
                            <Space size="middle">
                                {AttendantsEarinngRead && (
                                    <Button onClick={() => showPaymentDrawer(record)} className="h-10 bg-black text-white hover:!border-black hover:!bg-transparent hover:!text-black hover:transition hover:duration-500 hover:ease-in-out">Show History</Button>
                                )}
                                {AttendantsEarinngEdit && (
                                    <Button onClick={() => showDrawer(record)} className="h-10 bg-black text-white hover:!border-black hover:!bg-transparent hover:!text-black hover:transition hover:duration-500 hover:ease-in-out">Pay Attendant</Button>
                                )}
                            </Space>
                        )}
                    />

                </Table>

                <div>
                    <Pagination
                        currentPage={pageNumber.current}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                </div>

                <Drawer title="Payment History" width={520} onClose={onPaymentClose} open={paymentOpen} mask={false}>
                    {agentPaymentHistory && agentPaymentHistory.length > 0 ? (
                        agentPaymentHistory.map((payment: any) => (
                            <div className="bg-gray-100 p-5 border rounded-lg mb-4 shadow-sm" key={payment.agentEarningPaymentHistoryID}>
                                <div className="flex flex-col md:flex-row justify-between items-start gap-4">
                                    <div className="flex-1 w-[300px]">
                                        <p><span className="font-semibold">Paid Date:</span> {payment.updatedAt}</p>
                                        <p className="mt-2"><span className="font-semibold">Duration:</span> {payment.startDate} <span className="font-semibold"> To </span> {payment.endDate}</p>
                                        <p className="mt-2"><span className="font-semibold">Comment:</span> {payment.comment}</p>
                                    </div>
                                    <div className="text-right flex flex-col justify-between min-w-[150px]">
                                        <p>
                                            <span className="font-bold">Amount Paid: </span>${payment.amountPaid}
                                        </p>
                                        <p className="font-bold">
                                            {payment.paymentProofImage ? (
                                                <Link
                                                    to={payment.paymentProofImage}
                                                    target="_blank"
                                                    className="mt-2 text-blue-500 hover:underline"
                                                >
                                                    View Proof
                                                </Link>
                                            ) : (
                                                <span className="mt-2 text-gray-400 cursor-not-allowed">View Proof</span>
                                            )}
                                        </p>

                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center text-gray-500">No payment history available.</p>
                    )}
                </Drawer>

                <Drawer title={'Update Attendant Earning'} width={470} onClose={onClose} open={open} mask={false}>
                    <div>
                        <Form form={form} layout="vertical" onFinish={onFinish} >
                            <Form.Item name="agentID" hidden><Input /></Form.Item>
                            <Row gutter={16}>
                                <Form.Item
                                    name="agentID"
                                    label="Place ID"
                                    style={{ display: 'none' }}>
                                    <Input type="hidden" />
                                </Form.Item>
                                <Col span={24}>
                                    <Form.Item name="paymentProofImage" label={getLabel("Upload Payment Receipt", true)}>
                                        <Upload
                                            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                            listType="picture-card"
                                            fileList={featuredImage}
                                            onPreview={handlePreview}
                                            onChange={handleImageChange}
                                            onRemove={e => onDeleteFeatureImageFile(e)}
                                        >
                                            {featuredImage.length >= 1 ? null : uploadButton}
                                        </Upload>
                                    </Form.Item>
                                    <Form.Item
                                        name="comment"
                                        label="Remark">
                                        <Input.TextArea
                                            className="!h-[150px]"
                                            style={{ resize: 'none', paddingTop: '10px' }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Modal open={previewVisible} footer={null} onCancel={handlePreviewCancel}>
                                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                </Modal>
                                <div className="flex justify-end w-full gap-5">
                                    <div className="flex gap-2">
                                        <Button
                                            type="default"
                                            onClick={onClose}
                                            className="h-10 text-black border-black hover:bg-black hover:text-white hover:transition hover:duration-500 hover:ease-in-out"
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            loading={loading}
                                            type="primary"
                                            htmlType="submit"
                                            disabled={isImageUploading}
                                            onClick={() => form.submit()}
                                            className="h-10 bg-black text-white hover:!border-black hover:!bg-transparent hover:!text-black hover:transition hover:duration-500 hover:ease-in-out"
                                        >
                                            Pay
                                        </Button>
                                    </div>
                                </div>
                            </Row>
                        </Form>
                    </div>
                </Drawer>

                <Modal
                    title={<span className="custom-modal-title">{getModalTitle()}</span>}
                    open={isConfirmModalVisible}
                    onOk={handleSave}
                    onCancel={handleCancel}
                    closeIcon={<CloseOutlined className="text-gray-500 hover:text-black" />}
                    footer={
                        <div>
                            <Button key="back" onClick={handleCancel} className="hover:!text-black hover:!border-black">
                                Cancel
                            </Button>
                            <Button key="submit" onClick={handleSave} className="bg-black text-white hover:bg-transparent hover:!text-black hover:!border-black">
                                Confirm
                            </Button>
                        </div>
                    }
                >
                    {getModelContent()}
                </Modal>
            </ConfigProvider>
        </div>
    );
}

export default AttendantsEarningPaymentHistory;